import { FirstPasswordData } from './../models/first-password-change.model';
import { ForgotPasswordData } from './../models/forgot-password-data.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from './../models/user.model';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	public challengeName: string | null = null;
	public session: string | null = null;
	public userId: string | null = null;

	constructor(
		private http: HttpClient,
		private toastr: ToastrService,
		private router: Router,
		private authService: AuthService
	) {}

	/**
	 * Create the login request for Operational users
	 * @param email super user email
	 * @param password super user password
	 * @returns Observable
	 */
	public login(email: string, password: string): Observable<any> {
		const url = environment.backend.userURL + '/op/login/';
		return this.http
			.post<any>(url, {
				email,
				password,
			})
			.pipe(
				map((user) => {
					if (
						user.AuthenticationResult &&
						user.AuthenticationResult.AccessToken
					) {
						if (user.super === true) {
							localStorage.setItem('superUser', 'true');
						} else if (user.admin === true) {
							localStorage.setItem('adminUser', 'true');
						}

						localStorage.setItem('accessHour', new Date().toString());

						this.authService.setCredentials(
							user.AuthenticationResult.AccessToken,
							user.AuthenticationResult.IdToken,
							user.AuthenticationResult.RefreshToken
						);
					}
					return user;
				}),
				catchError((err) => {
					if (err.status === 401) {
						this.toastr.error(
							'A senha ou email/número estão incorretos. Por favor, tente novamente'
						);
					}
					if (err.status === 500) {
						this.toastr.error(
							'Ocorreu um erro interno. Por favor recarregue a página e tente novamente'
						);
					}
					return throwError(err.error.message);
				})
			);
	}

	public refreshToken(): Observable<any> {
		const url = environment.backend.userURL + '/op/refresh';

		const headers = {
			'access-token': this.authService.accessToken,
			'refresh-token': this.authService.refreshToken,
		};

		return this.http.get<any>(url, { headers });
	}

	/**
	 * Creates a request to start the password recovery process
	 * @param email user email address
	 * @returns Observable
	 */
	public forgotPasswordOp(email: string): Observable<any> {
		const url = environment.backend.userURL + '/op/forgot-password';
		return this.http.post<any>(
			url,
			{ username: email },
			{ responseType: 'json' }
		);
	}

	/**
	 * 2nd step for password recovery process
	 * @param body Requisition Body
	 * @returns Observable
	 */
	public forgotConfirmPasswordOp(body: ForgotPasswordData): Observable<any> {
		const url = environment.backend.userURL + '/op/confirm-forgot-password';
		return this.http.post<any>(url, body, { responseType: 'json' });
	}

	/**
	 * Create the request to change Temporary Password
	 * @param body Requisition body
	 * @returns Observable
	 */
	public changeFirstPasswordOp(body: FirstPasswordData): Observable<any> {
		const url = environment.backend.userURL + '/op/reset-first-password/';
		return this.http.post(url, body);
	}

	/**
	 * Requisição para receber lista de usuários
	 * @returns Observable
	 */
	public getUserOp(): Observable<any> {
		const url = environment.backend.userURL + '/op/admin/users/';
		return this.http.get<any>(url, {
			headers: new HttpHeaders({
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			}),
		});
	}

	/**
	 * Create the request to update operational user information
	 * @param gender Gender to be updated
	 * @param name Name to be updated
	 * @returns Observable
	 */
	public updateUserB2g(gender: string, name: string): Observable<any> {
		let url = environment.backend.userURL;
		const superUser = Boolean(localStorage.getItem('superUser'));
		url = url + (superUser ? '/super/users/' : '/op/users/');
		let headers;

		if (Boolean(localStorage.getItem('superUser'))) {
			headers = new HttpHeaders({
				'nina-secret': '0rangotang0Azul',
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		} else {
			headers = new HttpHeaders({
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		}

		return this.http.put<any>(url, { gender, name }, { headers });
	}

	public updateUserPassword(
		currentPassword: string,
		newPassword: string
	): Observable<any> {
		let url = environment.backend.userURL;
		const superUser = Boolean(localStorage.getItem('superUser'));
		url = url + (superUser ? '/super/users/' : '/op/update/password');
		let headers;

		if (Boolean(localStorage.getItem('superUser'))) {
			headers = new HttpHeaders({
				'nina-secret': '0rangotang0Azul',
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		} else {
			headers = new HttpHeaders({
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		}

		return this.http.put<any>(
			url,
			{ current_password: currentPassword, new_password: newPassword },
			{ headers }
		);
	}

	public forgotPassword(phone: string): Observable<any> {
		const url = environment.backend.userURL + '/forgot-password';
		return this.http
			.post<any>(url, { phone_number: '+' + phone }, { responseType: 'json' })
			.pipe(
				catchError((err) => {
					return throwError(err.error.message);
				})
			);
	}

	public forgotConfirmPassword(data: any): Observable<any> {
		const url = environment.backend.userURL + '/confirm-forgot-password';
		return this.http.post<any>(url, data, { responseType: 'json' }).pipe(
			catchError((err) => {
				if (err.error.error === 'EXPIRED CODE') {
					this.toastr.error('Seu código expirou, por favor, peça o reenvio');
					this.router.navigate(['/auth/reset-password']);
				}
				return throwError(err.message);
			})
		);
	}

	/**
	 * Requisição para receber os usuários operacionais
	 * @returns Observable com lista de usuários operacionais
	 */
	public getB2GUsers(): Observable<any> {
		const url = environment.backend.userURL + '/op/admin/users';

		return this.http.get<any>(url);
		// return this.http.get<any>(url, { headers });
	}

	/**
	 * Create a request to resend code for user Phone number
	 * @param phone phone number
	 * @deprecated
	 * @returns Observable
	 */
	public resendCode(phone: string): Observable<any> {
		const url = environment.backend.userURL + '/users/resend-code';
		return this.http
			.post(url, { phone_number: '+' + phone }, { responseType: 'json' })
			.pipe(
				catchError((err) => {
					return throwError(err.error.message);
				})
			);
	}

	public changeFirstPassword(data: any): Observable<any> {
		const url = environment.backend.userURL + '/users/reset-first-password/';

		return this.http.post(url, data);
	}

	/**
	 * Create the request to query user information by user id
	 * @param id user id
	 * @returns Observable
	 */
	public getUser(id: string): Observable<any> {
		const superUser = Boolean(localStorage.getItem('superUser'));

		let url = environment.backend.userURL;

		url = url + (superUser ? '/super/users/b2c/' : '/op/users/b2c/') + id;
		let headers;

		if (Boolean(localStorage.getItem('superUser'))) {
			headers = new HttpHeaders({
				'nina-secret': '0rangotang0Azul',
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		} else {
			headers = new HttpHeaders({
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			});
		}

		return this.http.get<User>(url, { headers });
	}

	/**
	 * Requisição nível Administrativo para criar usuário Operador
	 * @param user, usuário
	 * @returns Observable para efetuar o registro
	 */
	public createAdminUser(user: any): Observable<any> {
		const url = environment.backend.userURL + '/op/admin/users/';

		return this.http.post<any>(url, user, {
			headers: new HttpHeaders({
				Authorization: `${localStorage.getItem('idToken')}`,
				'access-token': `${localStorage.getItem('accessToken')}`,
			}),
		});
	}

	/**
	 * Create a request to get user information
	 * @returns Observable, Dados do próprio usuário
	 */
	public getSelfUserOp(): Observable<User> {
		let url = environment.backend.userURL;
		const superUser = Boolean(localStorage.getItem('superUser'));

		let headers;

		url = url + (superUser ? '/super/users/' : '/op/users/');

		if (Boolean(localStorage.getItem('superUser'))) {
			headers = new HttpHeaders({
				'nina-secret': '0rangotang0Azul',
				Authorization: this.authService.idToken,
				'access-token': this.authService.accessToken,
			});
		} else {
			headers = new HttpHeaders({
				Authorization: this.authService.idToken,
				'access-token': this.authService.accessToken,
			});
		}

		return this.http.get<User>(url, { headers });
	}

	/**
	 * Create the request to search for user by contact (email or phone number)
	 * @params Contact ( email | phone )
	 * @returns Observable
	 */
	public getUserByContact(contact: string): Observable<any> {
		const url = environment.backend.userURL + '/users/contact';
		const data = { contact };
		const text = JSON.stringify(data);
		return this.http.post(url, text);
	}
}
